var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideocam24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "videocam_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/av/videocam_24px",
    d: "M21.25 13.125V8.75C21.25 8.0625 20.6875 7.5 20 7.5H5C4.3125 7.5 3.75 8.0625 3.75 8.75V21.25C3.75 21.9375 4.3125 22.5 5 22.5H20C20.6875 22.5 21.25 21.9375 21.25 21.25V16.875L26.25 21.875V8.125L21.25 13.125Z",
    fill: "#E3E3E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocam24Px);
export default __webpack_public_path__ + "static/media/videocam_24px.349895af1c0634a641d288223e648e9e.svg";
export { ForwardRef as ReactComponent };